export default __webpack_public_path__ + "static/media/gold1.4bd16026.mp3";